import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./readyToLeap.css";
import htmlParser from "html-react-parser";
import ContactUsForm from "../ContactUS Form/ContactUsForm";
import LoanOfficer from "../LoanOfficerInfo/LoanOfficerInfo";

export default function FAQSection({ loanOfficer, loInformation, faqData }) {
  const imgURL = process.env.REACT_APP_CDN_URL;

  // console.log("FAQ Data:", faqData); 

  const safeParse = (value) => (value ? htmlParser(value) : "");

  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = phoneNumber.replace(/\D/g, ""); // Remove all non-digit characters
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/); // Match the desired format
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`; // Format as (XXX) XXX-XXXX
    }
    return phoneNumber; // Return original if it doesn't match
  };

  if (faqData) {
    return (
      <div className="LoSpecific">
        <Container>
          <Row>
            <Col md={12} sm={12} lg={7} xl={8}>
              <div className="LoSpecific-Section">
                {loanOfficer ? (
                  <Col sm={12}>
                    <LoanOfficer loanOfficer={loanOfficer} />
                    <div className="ReadyToLeap">
                      <h4>Ready to Take the Leap?</h4>
                      <p>
                        To learn more about becoming an Ai-powered MLO at Sun
                        West Mortgage Company, Inc., reach out to me at{" "}
                        <a
                          href={`tel:+1${loanOfficer?.workPhoneNumber?.replace(
                            /\D/g,
                            ""
                          )}`}
                          style={{ color: "#00AAE4", textDecoration: "none" }} // Fixed color code
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {formatPhoneNumber(loanOfficer?.workPhoneNumber)}{" "}
                          {/* Prepend D: to the formatted number */}
                        </a>{" "}
                        or{" "}
                        <a
                          href={`https://${loanOfficer?.userWebsite}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#00AAE4", textDecoration: "none" }} // Fixed color code
                        >
                          {safeParse(loanOfficer?.userWebsite)}
                        </a>
                        . Join our team today and unlock the doors to a
                        successful career in real estate and mortgage
                        origination!
                      </p>
                      <p>{htmlParser(faqData.faqText2)}</p>
                    </div>
                  </Col>
                ) : (
                  <>
                    {/* Render the images and text based on faqData */}
                    <img
                      src={`${imgURL}${faqData.LoImage}`}
                      className="AngelAi-Circle"
                      alt="AngelAi Logo"
                    />
                    <img
                      src={`${imgURL}${faqData.CallUsImage}`}
                      className="CallUS-Background"
                      alt="Call Us Background"
                    />
                    <p className="CallUsText">
                      {htmlParser(faqData.CallUsText)}
                    </p>
                    <div className="ReadyToLeap">
                      <h4>{htmlParser(faqData.faqHeading)}</h4>
                      <p>{htmlParser(faqData.faqText1)}</p>
                      <p>{htmlParser(faqData.faqText2)}</p>
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col>
              <Col sm={12} id="contactus">
                <ContactUsForm
                  loanOfficer={loanOfficer}
                  loInformation={loInformation}
                />
              </Col>
            </Col>
          </Row>
        </Container>
      </div>
    );
  } else {
    return <></>; // Return empty if faqData is not available
  }
}
